import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header";
import "../Styles/Cv.css";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";
import BackArrow from "../Components/BackArrow";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faAddressCard,faPaperPlane} from '@fortawesome/free-solid-svg-icons';
import { faStripe, faGithub, faDocker, faHtml5, faSquareJs, faNode, faCss3, faReact, faVuejs, faMicrosoft } from '@fortawesome/free-brands-svg-icons';

/* import {faStripe} from '@fortawesome/fontawesome-free/css/brands.css'; */


export default function Cv() {
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const [showContent, setShowContent] = useState(false)
  const [password, setPassword] =useState("")
  const [error, setError] = useState("");
  const [cvData, setCvData] = useState(null)
  const containerRef = useRef(null);

  const API_URI = window.location.hostname === "localhost" && "127.0.0.1" ? "http://localhost:5000" : "https://philipjanssondev-backend.vercel.app"

  const validatePassword = async () => {
    setError("");
    const res = await fetch(`${API_URI}/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password })
    });
    if (!res.ok) return setError("The password is incorrect.");
  
    const { token, expiresIn } = await res.json();
    localStorage.setItem("cv_token", token);
    localStorage.setItem("cv_token_exp", String(Date.now() + expiresIn * 1000));
    await bootstrap(); 
  };
  
  async function authHeader() {
    const t = localStorage.getItem("cv_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
  }
  
  async function bootstrap() {
    const v = await fetch(`${API_URI}/auth/validate`, { headers: await authHeader() });
    if (!v.ok) { setShowContent(false); return; }
    setShowContent(true);
    const r = await fetch(`${API_URI}/cv/data`, { headers: await authHeader() });
    if (r.ok) setCvData(await r.json());
  }
  
  useEffect(() => { bootstrap(); }, []);
  


  const sectionsRef = useRef([]);

  useEffect(() => {
     if (!showContent){
      return
  }
    const handleMouseMove = (event) => {
      const topColumn = document.querySelector(".top-column");
      const topColumnRect = topColumn.getBoundingClientRect();

      // Kolla om musen är utanför top-column
      if (
        !isMobile &&
        (event.clientY > topColumnRect.bottom ||
          event.clientX < topColumnRect.left ||
          event.clientX > topColumnRect.right)
      ) {
        setMousePosition({
          x: event.clientX,
          y: event.clientY,
        });
      }
    };

    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("resize", checkIsMobile);

    checkIsMobile(); 

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [isMobile, showContent]);

  const contactMe = () => {
    navigate("/contact-me");
  };


  useEffect(() => {
    if (!showContent) return;
    const root = containerRef.current;
    if (!root) return;
  
    const els = root.querySelectorAll('.fade-in:not(.visible)');
    if (!els.length) return;
  
    const obs = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // tweak så animationen triggar lite innan helt synlig
        threshold: 0.1,
        root: null,
        rootMargin: '0px 0px -10% 0px',
      }
    );
  
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [showContent, cvData]);


  return (
    <>  
       <Header />
          {!showContent ? (
        <div className="password-container">
          <h2>Enter the password to view content</h2>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
          <button onClick={validatePassword}>Submit</button>
          {error && <p className="error-message">{error}<br></br><br></br>Call me at +46760-549046 or through <a href="/contact-me">this</a> form to get access to my CV :)</p>}
        </div>
      ) : (
     <div className="wrapper">
 
      <BackArrow /> 

      <div className="cv-container" ref={containerRef}>
      <div className="top-column">

          <div className="cv-header fade-in">
            <h1>{cvData?.hero?.name}</h1>
            <h2>{cvData?.hero?.role}</h2>
          </div>

 
          <div className="contacts fade-in">
      {(cvData?.hero?.contacts || []).map((c, i) => (
        <span className="contact-item" key={i}>
          <FontAwesomeIcon className="contact-icon"
            icon={c.type === "phone" ? faPhone : c.type === "email" ? faPaperPlane : faAddressCard}
          />
          <h2>{c.href ? <a href={c.href}>{c.label}</a> : c.label}</h2>
        </span>
      ))}
    </div>
        </div>

        <div className="bottom-column">
          <section className="about-me fade-in">
            <div className="heading">
              <h1>Profile</h1>
            </div>

            <div className="cv-description fade-in">
            <p className="summary" dangerouslySetInnerHTML={{ __html: cvData?.profile?.summary }}></p>
          </div>


          </section>

          <section className="experience fade-in">
            <div className="heading">
              <h1>Experience</h1>
            </div>

           
        {(cvData?.experience || []).map((item, i) => (
          <div className="experience-item fade-in" key={item.id || i}>
            <div className="item-heading">
              <h1>
                {item.title}
                {item.company ? `, ${item.company}` : ""}
                {item.location ? `, ${item.location}` : ""}
              </h1>
            </div>

            <div className="duration">
              <p>{item.dateLabel}</p>
            </div>

            <div className="item-description">
              {item.summary && <p className="summary">{item.summary}</p>}
              {item.summaryHtml && (
                <p
                  className="summary"
                  dangerouslySetInnerHTML={{ __html: item.summary }}
                />
              )}
              
            </div>
          </div>
        ))}
          </section>

         

          <section className="education fade-in">
            <div className="experience">
              <h1 className="education-heading">Education</h1>
            </div>
            {(cvData?.education || []).map((item, i) => (
          <div className="experience-item fade-in" key={item.id || i}>
            <div className="item-heading">
              <h1>{item.school}{item.location ? `, ${item.location}` : ""}</h1>
            </div>

            <div className="duration">
              <p>{item.dateLabel}</p>
            </div>

            <div className="item-description">

              {item.summary && <p className="summary">{item.summary}</p>}
              {item.summaryHtml && (
                <p
                  className="summary"
                  dangerouslySetInnerHTML={{ __html: item.summaryHtml }}
                />
              )}

              
              {Array.isArray(item.bullets) && item.bullets.length > 0 && (
                <>
                  
                  <ul>
                    {item.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        ))}


          </section>

          <section className="skills fade-in">
            <div className="experience">
              <h1>Skills</h1>
            </div>

            <div className="skills-items">
              <div className="skills-item">
                <h2>HTML</h2>
                <FontAwesomeIcon className="skills-icon"  icon={faHtml5} style={{color: "red"}}/>
              </div>

              <div className="skills-item">
                <h2>CSS</h2>
                <FontAwesomeIcon className="skills-icon"  icon={faCss3} style={{color: "blue"}}/>
              </div>

              <div className="skills-item">
                <h2>Javascript</h2>
                <FontAwesomeIcon className="skills-icon"  icon={faSquareJs} style={{color: "black"}}/>
              </div>

              <div className="skills-item">
                <h2>Typescript</h2>
                <img src="/ts.png" className="skills-icon" alt="ts"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/React-Logo.png" alt="React"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/Vuejs.png" alt="Vuejs"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/node.png" alt="Node"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/nodeexpress.png" alt="Express"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/Firebase_Logo.svg" alt="Firebase"/>
              </div>

              <div className="skills-item">
                <img className="skills-img"  src="/MongoDbLogo.png" alt="MongoDB"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/azure.svg" alt="Azure"/>
              </div>

              <div className="skills-item">
                <img className="skills-img" src="/sql-logo.png" alt="sql"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/sqlworkbench.png" alt="SQL Workbench"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/docker.png" alt="Docker"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/github.png" alt="Github"/>
              </div>
              
              <div className="skills-item">
                <img className="skills-img"  src="/netsuite.png" alt="Netsuite"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/owasp.png" alt="OWASP"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/agile.png" alt="Agile"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/stripe.png" alt="Stripe"/>
              </div>

              <div className="skills-item">
                <h2>Kali&nbsp;Linux</h2>
              <img className="skills-img"  src="/kali.png" alt="Kali"/>
              </div>

              <div className="skills-item">
              <img className="skills-img" id="burp"  src="/burp.png" alt="Burp"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/dotnet.png" alt="Dotnet"/>
              </div>

              <div className="skills-item">
              <img className="skills-img"  src="/entity.png" alt="Entity"/>
              </div>
            </div>

            {isMobile && (
              <button className="fixed-button" onClick={contactMe}>
                Contact me!
              </button>
            )}
          </section>
        </div>
      </div>

      <Footer />

      {!isMobile && (
        <button
          className="follow-mouse-button"
          style={{ top: mousePosition.y, left: mousePosition.x }}
          onClick={contactMe}
        >
          Contact me!
        </button>
      )}
    </div>
      )}
    </>
      
  );
}
